module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAsCAMAAAAkRNp0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRF0ObczNzU29zc2urjx9LM6fLs9PT04e/n6enp+fr51ung4ePi7/by0dHR////3u7pYDyEuQAAAPtJREFUeNqs1esOgyAMBeBikUJVeP+3HVDmblHPEs+fQfYRmjPNKPcIi8z5PGQfXGqIuMicLqiWPUrarliPKJXvcL3j84jRpOUo9Yi2M7Ianct1xKjcS5leXZ3HLziNdNDVz/U+oJSi9Qp0RQGnySjQFY0flm+lblC6lY4BVmAANoo8goMiz5UaBeRzVsap4rMS8rp0mhSmSFdjALmZ2gBIV2XuVHGKdKWhUagr6hTqyqiAT8t/9Ksr5nNK3jvniGzZ1nWjn29hpe17t1mq8tuet0NG28Zt5/FGp7bOIcQ42TKntllsNzJ1+lxZUnj/q9oPGU0hLjEDeQgwAH+CYgHeIbEtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/NM.png
// module id = Q56x
// module chunks = 1